import axios from 'axios'
import { StoredCollaboratorAccess } from './components/CnCollaboratorAccess'
import { Status } from './components/CnStatus'
import { ContactInfo } from './components/CnGeneralConfiguration'

interface CnSoftAccessFormPayload {
  cn_cols_data: string
  access_collaborator?: string
  agencies: string
  rg2: string
  status?: string
  administrator_access_collaborator?: string
  ms_pro: boolean
  name?: string
  deletedGroupementsIds: string
  rg3_default_tab?: string
  custom_contact_support?: string
  datahub?: string
}

export function formatAccessCollaborator(
  rows: Array<{
    coll_id: string
    access_collaborator: boolean
    no_excel_export: boolean
    mass_modification: boolean
    access_export_contacts: boolean
  }>,
): string {
  const dataAccess = rows.map((row) => {
    const entry: StoredCollaboratorAccess = {
      coll_id: row.coll_id,
      access_collaborator: row.access_collaborator,
      mass_modification: row.mass_modification,
      access_export_contacts: row.access_export_contacts,
    }
    if (row.no_excel_export === false) {
      entry.no_excel_export = false
    }
    return entry
  })
  return JSON.stringify(dataAccess)
}

export function formatAdministratorAccess(collId: string): string {
  if (!collId) {
    return ''
  }
  return JSON.stringify({ parameters_administrator: { coll_id: collId } })
}

export function formatCustomContactSupport(contact: ContactInfo | null): string {
  return JSON.stringify(contact)
}

export function formatStatus(status: Status[]): string {
  return JSON.stringify(status)
}

function buildCnSoftAccessFormBody(payload: CnSoftAccessFormPayload): URLSearchParams {
  const body = new URLSearchParams()
  body.set('cn_cols_data', payload.cn_cols_data)
  body.set('agencies', payload.agencies)
  body.set('rg2', payload.rg2)
  body.set('ms_pro', String(payload.ms_pro))
  body.set('deletedGroupementsIds', payload.deletedGroupementsIds)

  if (payload.access_collaborator !== undefined) {
    body.set('access_collaborator', payload.access_collaborator)
  }
  if (payload.status !== undefined) {
    body.set('status', payload.status)
  }
  if (payload.administrator_access_collaborator !== undefined) {
    body.set('administrator_access_collaborator', payload.administrator_access_collaborator)
  }
  if (payload.name !== undefined) {
    body.set('name', payload.name)
  }
  if (payload.rg3_default_tab !== undefined) {
    body.set('rg3_default_tab', payload.rg3_default_tab)
  }
  if (payload.custom_contact_support !== undefined) {
    body.set('custom_contact_support', payload.custom_contact_support)
  }
  if (payload.datahub !== undefined) {
    body.set('datahub', payload.datahub)
  }

  return body
}

interface CnSoftAccessSaveResponse {
  ok: boolean
  softaccessId?: string
  redirect?: string
  errors?: unknown
}

export async function saveCnSoftAccess(
  orgaId: string,
  softaccessId: string | undefined,
  payload: CnSoftAccessFormPayload,
): Promise<CnSoftAccessSaveResponse> {
  const body = buildCnSoftAccessFormBody(payload)
  const isNew = !softaccessId || softaccessId === 'new'
  const url = isNew
    ? `/organisations/${orgaId}/cn/softwaresaccesses`
    : `/organisations/${orgaId}/cn/softwaresaccesses/${softaccessId}`

  const { data } = await axios.post<CnSoftAccessSaveResponse>(url, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    validateStatus: status => status < 500,
  })

  if (!data.ok) {
    throw new Error('Save failed')
  }

  return data
}
